import { Quill } from "react-quill-new";

const Embed = Quill.import("blots/embed");

class UserMentionBlot extends Embed {
  static create(value) {
    const node = super.create();
    node.setAttribute("data-user-uid", value.uid || "");
    node.setAttribute("data-user-email", value.email || "");
    node.setAttribute("data-user-name", value.name || value.email || "");
    node.setAttribute("contenteditable", "false");
    node.textContent = `@${value.name || value.email || ""}`;
    return node;
  }

  static value(node) {
    return {
      uid: node.getAttribute("data-user-uid"),
      email: node.getAttribute("data-user-email"),
      name: node.getAttribute("data-user-name"),
    };
  }
}

UserMentionBlot.blotName = "user-mention";
UserMentionBlot.tagName = "span";
UserMentionBlot.className = "user-mention";

Quill.register(UserMentionBlot);

export default UserMentionBlot;
